import React, { useState, useEffect, useContext } from "react";
import { Container, Row, Col, Table, Form, Button } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { apiGet } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import { isEmpty, startCase } from "lodash";
import ReactPaginate from "react-paginate";
import helpers from "../../utils/helpers";
import AuthContext from "../../context/AuthContext";
import moment from "moment";
import { BiSolidRightArrow } from "react-icons/bi";
import DatePicker from "react-datepicker";
import Pagination from "../../components/Pagination";

const TransactionLogs = () => {
  const location_params = useParams();
  var previousDate = moment().subtract(1, "days").format("YYYY-MM-DD");
  var currentDate = moment().format("YYYY-MM-DD");
  let { user } = useContext(AuthContext);
  const [getLogData, setLogData] = useState("");
  const [pageCount, setPageCount] = useState(0);
  const [search_params, setSearchParams] = useState({
    page: 1,
    limit: 100,
    fromPeriod: previousDate,
    toPeriod: currentDate,
    filterByDay: "",
    user_id: "id" in location_params ? location_params?.id : undefined,
  });
  const myLogData = async () => {
    const { status, data: response_users } = await apiGet(
      apiPath.transactionTxnLogs,
      search_params
    );
    if (status === 200) {
      if (response_users.success) {
        setLogData(response_users.results);
      }
    }
  };
  const handlePageClick = (event) => {
    setSearchParams((prevState) => {
      return {
        ...prevState,
        page: event.selected + 1,
      };
    });
  };

  useEffect(() => {
    setPageCount(getLogData?.totalPages || []);
  }, [getLogData]);

  useEffect(() => {
    myLogData();
  }, [search_params]);

  return (
    <div>
      <section className="main-inner-outer">
        <Container fluid>
          <Row>
            <Col className="p-0 m-0" lg={12} md={12}>
              <div className="inner-wrapper">
                <h2 className="common-heading banking-com-h">
                  Banking Logs{" "}
                  {/* <span>
                    {" "}
                    {location_params?.username
                      ? location_params?.username
                      : ""}{" "}
                  </span> */}
                  <a className="pop-close" onClick={() => window.close()}>
                    <img
                      className="icon-back"
                      src="assets/images/transparent.gif"
                    />
                    Close
                  </a>
                </h2>
                {location_params?.id == undefined && (
                  <Col md={12}>
                    <div className="inner-wrapper">
                      <Form className="bet_status">
                        <Row>
                          <div className="d-flex align-items-center">
                            <div
                              className="bet-sec"
                              style={{ marginRight: "10px" }}
                            >
                              <Form.Label className="mb-0">
                                Time Zone
                              </Form.Label>
                              <Form.Select
                                className="small_select"
                                style={{ minWidth: "80px", width: "120px" }}
                                onChange={(e) =>
                                  setSearchParams({
                                    ...search_params,
                                    timeZone: e.target.value,
                                  })
                                }
                                value={search_params.timeZone}
                                aria-label="Default select example"
                              >
                                <option value={""}>
                                  IST(Bangalore / Bombay / New Delhi) (GMT+5:30)
                                </option>
                              </Form.Select>
                            </div>

                            <div className="bet-sec" style={{ width: "240px" }}>
                              <Form.Label className="mb-0">Period</Form.Label>
                              <Form.Group className="form-group">
                                <DatePicker
                                  className="small_form_control"
                                  selected={
                                    search_params.fromPeriod
                                      ? new Date(search_params.fromPeriod)
                                      : null
                                  }
                                  onChange={(date) =>
                                    setSearchParams({
                                      ...search_params,
                                      fromPeriod: date
                                        .toISOString()
                                        .split("T")[0],
                                      filterByDay: "",
                                    })
                                  }
                                  dateFormat="yyyy-MM-dd"
                                  maxDate={new Date()}
                                  showMonthDropdown
                                  showYearDropdown
                                  dropdownMode="select" // or "scroll" if you prefer scroll-style dropdowns
                                  placeholderText="Select a date"
                                  onFocus={(e) => e.target.blur()}
                                />
                                <Form.Control
                                  style={{
                                    marginLeft: "4px",
                                    width: "47px",
                                  }}
                                  className="small_form_control"
                                  type="text"
                                  placeholder="09:00"
                                  disabled
                                />
                              </Form.Group>
                            </div>

                            <div className="bet-sec ">
                              <Form.Label
                                style={{ marginRight: "2px" }}
                                className="mb-0"
                              >
                                to
                              </Form.Label>
                              <Form.Group className="form-group">
                                <DatePicker
                                  className="small_form_control"
                                  selected={
                                    search_params.fromPeriod
                                      ? new Date(search_params.fromPeriod)
                                      : null
                                  }
                                  onChange={(date) =>
                                    setSearchParams({
                                      ...search_params,
                                      toPeriod: date
                                        .toISOString()
                                        .split("T")[0],
                                      filterByDay: "",
                                    })
                                  }
                                  dateFormat="yyyy-MM-dd"
                                  minDate={
                                    search_params?.fromPeriod
                                      ? new Date(search_params?.fromPeriod)
                                          .toISOString()
                                          .split("T")[0]
                                      : new Date()
                                  }
                                  maxDate={
                                    new Date().toISOString().split("T")[0]
                                  }
                                  showMonthDropdown
                                  showYearDropdown
                                  dropdownMode="select" // or "scroll" if you prefer scroll-style dropdowns
                                  placeholderText="Select a date"
                                  onFocus={(e) => e.target.blur()}
                                />
                                <Form.Control
                                  style={{
                                    marginLeft: "4px",
                                    width: "47px",
                                  }}
                                  className="small_form_control"
                                  type="text"
                                  placeholder="08:59"
                                  disabled
                                />
                              </Form.Group>
                            </div>
                          </div>
                        </Row>
                        <div className="history-btn mt-2">
                          <ul className="list-unstyled mb-0">
                            <li>
                              <Button
                                className={
                                  search_params.filterByDay === "today"
                                    ? "me-0 theme_dark_btn"
                                    : "me-0 theme_light_btn"
                                }
                                onClick={(e) =>
                                  setSearchParams({
                                    ...search_params,
                                    filterByDay: "today",
                                  })
                                }
                                style={{
                                  padding: `0 10px`,
                                  lineHeight: `25px`,
                                }}
                              >
                                Just For Today
                              </Button>
                            </li>
                            <li>
                              <Button
                                className={
                                  search_params.filterByDay === "yesterday"
                                    ? "me-0 theme_dark_btn"
                                    : "me-0 theme_light_btn"
                                }
                                onClick={(e) =>
                                  setSearchParams({
                                    ...search_params,
                                    filterByDay: "yesterday",
                                  })
                                }
                                style={{
                                  padding: `0 10px`,
                                  lineHeight: `25px`,
                                }}
                              >
                                From Yesterday
                              </Button>
                            </li>
                            <li>
                              <Button
                                className="theme_dark_btn"
                                onClick={() => myLogData("search")}
                              >
                                Get History
                              </Button>
                            </li>
                          </ul>
                        </div>
                      </Form>
                    </div>
                  </Col>
                )}
                <section className="account-table">
                  <div className="responsive transaction-history">
                    <Table className="w-100">
                      <thead>
                        <tr>
                          <th scope="col">Date/Time</th>
                          <th style={{ textAlign: "right" }} scope="col">
                            Deposit
                          </th>
                          <th style={{ textAlign: "right" }} scope="col">
                            Withdraw
                          </th>
                          <th style={{ textAlign: "right" }} scope="col">
                            Balance{" "}
                          </th>
                          <th style={{ textAlign: "right" }} scope="col">
                            Remark
                          </th>
                          <th
                            style={{ textAlign: "right", width: "15%" }}
                            scope="col"
                          >
                            From/To
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {getLogData.data &&
                          getLogData.data.map((item, key) => (
                            <tr key={key}>
                              <td>
                                {helpers.tdateFormat(
                                  item?.createdAt,
                                  user?.timeZone
                                )}
                              </td>
                              <td style={{ textAlign: "right" }}>
                                {item?.transactionType == "credit" ? (
                                  <span className="classsuc">
                                    {helpers.currencyFormat(
                                      Math.abs(item?.amount)
                                    )}
                                  </span>
                                ) : (
                                  "-"
                                )}
                              </td>

                              <td style={{ textAlign: "right" }}>
                                {item?.transactionType == "debit" ? (
                                  <span className="text-danger">
                                    {"(" +
                                      helpers.currencyFormat(
                                        Math.abs(item?.amount)
                                      ) +
                                      ")"}
                                  </span>
                                ) : (
                                  "-"
                                )}
                              </td>

                              <td style={{ textAlign: "right" }}>
                                {helpers.currencyFormat(item?.newBalance)}
                              </td>
                              <td style={{ textAlign: "right" }}>
                                {item?.remark}
                              </td>
                              <td style={{ textAlign: "right" }}>
                                {startCase(item?.createdByData?.userType)}{" "}
                                <BiSolidRightArrow
                                  className="angle_unicode"
                                  color="rgb(197,208,215)"
                                  size={11}
                                />
                                {item?.userData?.username}
                              </td>
                            </tr>
                          ))}
                        {isEmpty(getLogData.data) ? (
                          <tr>
                            <td colSpan={9}>No records found</td>
                          </tr>
                        ) : null}
                      </tbody>
                    </Table>
                    {/* <div className="bottom-paginatiyon">
                      <ReactPaginate
                        breakLabel="..."
                        nextLabel=" Next"
                        onPageChange={handlePageClick}
                        pageRangeDisplayed={10}
                        pageCount={pageCount}
                        previousLabel="Prev "
                        renderOnZeroPageCount={null}
                        activeClassName="p-1"
                        activeLinkClassName="pagintion-li"
                      />
                    </div> */}
                    {getLogData.data && getLogData.data?.length > 0 && (
                      <Pagination
                        handlePageClick={handlePageClick}
                        pageCount={pageCount}
                        viewpage={0}
                      />
                    )}
                  </div>
                </section>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default TransactionLogs;
